var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{attrs:{"slot":"component","invalid-feedback":_vm.invalidFeedback,"state":_vm.erroDoCampo && _vm.erroDoCampo.campo == null},slot:"component"},[_c('label',{attrs:{"for":"vat"}},[_vm._v(_vm._s(_vm.campoDescritivo))]),(_vm.small)?_c('small',[_vm._v(" "+_vm._s(_vm.small))]):_vm._e(),_vm._t("component")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }